import React, { useState } from "react";
import { useSelector } from "react-redux";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import { useQuery } from "@apollo/client";
import { GET_ALL_ROOMS } from "graphql/service";
import { OverviewContainer, NavigatorContainer, Navigator } from "./styles";

const HotelOverview = () => {
  const currentRoom = useSelector((state) => state.selectReducer.currentRoom);
  const [cafeInfoArray, setCafeInfoArray] = useState([]);

    const { data: hotelOverviewData, loading, error } = useQuery(GET_ALL_ROOMS, {
    onCompleted: (hotelOverviewData) => {
      const newArray = [];
      hotelOverviewData.hotelOverview.forEach((cafeInfo, index) => {
        newArray.push(
          <tr key={index}>
            <td className="date">{cafeInfo.date}</td>
            <td className="rooms">{cafeInfo.rooms}</td>
            <td className="breakfasts">{cafeInfo.breakfasts}</td>
          </tr>
        );
      });
      setCafeInfoArray(newArray);
    },
  });

  const [pageNumber, setPageNumber] = useState(1)
  const pageSize = 3
  const pageCount = Math.ceil(hotelOverviewData?.hotelOverview?.length/pageSize)

  const paginate = (array, page_size, page_number) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array?.slice((page_number - 1) * page_size, page_number * page_size);
  }

  const previousPage = () => {
    if(pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber-1)
    }
  }

  const nextPage = () => {
    if(pageNumber < pageCount) {
      setPageNumber((pageNumber) => pageNumber+1)
    }
  }

  return (
    <Card
      className="hotelOverview"
      additionalstyle={`
        width: 100%;
        max-width: 379px;
        height: 100%;
        margin: 20px;
        padding: 0;
      `}
    >
      <CardHeader
        additionalstyle={`

        margin: 16px;

        .type {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 1px;
        }
      `}
      >
        <div className="type">Hotel Overview</div>
        {cafeInfoArray?.length > pageSize ? (
          <NavigatorContainer>
            <Navigator
              disabled={pageNumber <= 1}
              onClick={previousPage}
            >
              {"<"} Back
            </Navigator>
            <Navigator
              disabled={pageNumber >= cafeInfoArray.length / pageSize}
              onClick={nextPage}
            >
              Next {">"}
            </Navigator>
          </NavigatorContainer>
        ) : null}
      </CardHeader>
      <OverviewContainer>
        <thead>
          <tr>
            <th className="date">DATE</th>
            <th className="rooms">ROOMS</th>
            <th className="breakfasts">BREAKFASTS</th>
          </tr>
        </thead>
        <tbody>{cafeInfoArray}</tbody>
      </OverviewContainer>
    </Card>
  );
};

export default HotelOverview;
